import { FunctionComponent, useState } from 'react';
import css from './ThreadsList.module.less';
import cn from 'classnames';
import { Empty, Space, Spin } from 'antd';
import componentContent from '../../../pages/TribesPage/TribesPage.content.json';
import useTranslate from '@hooks/useTranslate';

import { RightCircleOutlined } from '@ant-design/icons';
import { ITribesChatDetailMessages } from '@interfaces/ITribes';
import TribeMessage from '../TribeMessage';

interface ThreadsProps {
  messages: ITribesChatDetailMessages[];
  isListLoading: boolean;
  onOpen: (value: boolean) => void;
}

const Threads: FunctionComponent<ThreadsProps> = (props) => {
  const [isOpened, setIsOpened] = useState(false);
  const content = useTranslate(componentContent);
  const { messages, isListLoading, onOpen } = props;
  const isDisplayList = isOpened && !!messages.length;
  const isDisplayEmptyList = isOpened && !messages.length && !isListLoading;

  const classNameIcon = cn(css.icon, { [css.iconActive]: isOpened });
  const classNameContent = cn({
    [css.contentHidden]: !isOpened,
    [css.contentNone]: !(isDisplayList || isDisplayEmptyList),
  });

  const handleOpen = () => {
    setIsOpened(!isOpened);
    onOpen(!isOpened);
  };

  return (
    <div className={css.membersList}>
      <Space onClick={handleOpen}>
        <RightCircleOutlined className={cn('clickable', classNameIcon)} />
        <span className={cn(css.text, 'clickable')}>
          {isOpened ? content.hide : content.show_threads}
        </span>
      </Space>
      <section className={classNameContent}>
        <Spin spinning={isListLoading}>
          {isDisplayList &&
            messages.map((item: ITribesChatDetailMessages) => {
              const { id } = item;
              return (
                <TribeMessage
                  message={item}
                  key={id}
                  className={'thread'}
                />
              );
            })}
          {isDisplayEmptyList && (
            <Empty
              className={css.emptyContainer}
              imageStyle={{ height: '50px' }}
            />
          )}
        </Spin>
      </section>
    </div>
  );
};
export default Threads;
